var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "payment myqr" },
    [
      _c("popup", {
        ref: "popup",
        attrs: {
          opened: _vm.openData,
          "use-header": true,
          "use-footer": true,
          "btn-area-padding": true,
          title: "MPAY-05-01-01-01"
        },
        on: {
          "update:opened": function($event) {
            _vm.openData = $event
          },
          cancel: _vm.popupClose
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("article", { staticClass: "contents" }, [
                  _c("div", { staticClass: "myqr-wrap" }, [
                    _c("p", { staticClass: "logo-group" }, [
                      _c("span", { staticClass: "logo-group-item vietqr" }, [
                        _c("i", { staticClass: "icon myqr-logo-vietqr" }, [
                          _vm._v("VIETQR")
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "qr" }, [
                      _c("div", { ref: "myQrDiv2", attrs: { id: "myQr3" } }, [
                        _c("i", { staticClass: "icon myqr-sampleQR" })
                      ])
                    ]),
                    _c("p", { staticClass: "logo-group" }, [
                      _c("span", { staticClass: "logo-group-item" }, [
                        _c("i", { staticClass: "icon myqr-logo-napas247" }, [
                          _vm._v("NAPAS247")
                        ])
                      ]),
                      _c("span", { staticClass: "logo-group-item" }, [
                        _c("i", { staticClass: "icon myqr-logo-kbbank" }, [
                          _vm._v("KB Kookmin Bank")
                        ])
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "qrinfo-txt" }, [
                    _vm.detailInfo.amount != 0
                      ? _c("p", [
                          _vm._v(
                            _vm._s(/* 금액 */ _vm.$t("MPAY-05-01-01-04")) +
                              " : VND " +
                              _vm._s(_vm.$num(_vm.detailInfo.amount, 0))
                          )
                        ])
                      : _vm._e(),
                    _c("p", [
                      _vm._v(
                        _vm._s(/* 수취인명 */ _vm.$t("MPAY-05-01-01-02")) +
                          " : " +
                          _vm._s(_vm.detailInfo.beneName)
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(/*수취 계좌번호*/ _vm.$t("MFXD-01-03-01-03")) +
                          " : " +
                          _vm._s(_vm.detailInfo.account) +
                          "(VND)"
                      )
                    ]),
                    _vm.operGroupCd == "VN1"
                      ? _c("p", [
                          _vm._v(
                            _vm._s(/* 은행 */ _vm.$t("MFXD-01-01-11-05")) +
                              " : KOOKMIN HO CHI MINH - KB HCM"
                          )
                        ])
                      : _c("p", [
                          _vm._v(
                            _vm._s(/* 은행 */ _vm.$t("MFXD-01-01-11-05")) +
                              " : KOOKMIN HA NOI - KB HN"
                          )
                        ])
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function($event) {
                        return _vm.popupClose()
                      }
                    }
                  },
                  [_vm._v(_vm._s(/*확인*/ _vm.$t("MPAY-04-01-10-21")))]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }